import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { forkJoin } from 'rxjs';
import { CreditService } from '../../services/credit/credit.service';
import { CreditDashboard, CreditTypeCredit } from '../../interfaces/credit.interface';
import { etatListeDepuisParams, filtreActif } from '../../utils/dashboard-filtre-url';

export interface DashboardAgenceCreditResolvedData {
  dashboard: CreditDashboard;
  typesCredit: CreditTypeCredit[];
}

/** Les filtres étant dans l'URL, la résolution rejoue la recherche telle quelle. */
export const dashboardAgenceCreditResolver: ResolveFn<DashboardAgenceCreditResolvedData> = (
  route: ActivatedRouteSnapshot,
) => {
  const { filtre } = etatListeDepuisParams(route.queryParamMap);
  const svc = inject(CreditService);
  return forkJoin({
    dashboard: filtreActif(filtre) ? svc.filtrerDashboard(filtre) : svc.getDashboard(),
    typesCredit: svc.getTypesCredit(),
  });
};
